import { render } from "./MentionSuggest.vue?vue&type=template&id=a0e4e12a"
import script from "./MentionSuggest.vue?vue&type=script&lang=js"
export * from "./MentionSuggest.vue?vue&type=script&lang=js"

import "./MentionSuggest.vue?vue&type=style&index=0&id=a0e4e12a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__